var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerhome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 642,
    height: 654,
    viewBox: "0 0 642 654",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 642,
    height: 654,
    fill: "#EEEAFD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.883,
    y: 109,
    width: 249.084,
    height: 457.582,
    rx: 25.4654,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 213.102,
    y: 215.637,
    width: 173.483,
    height: 12.7327,
    rx: 6.36636,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.102,
    y: 252.369,
    width: 173.483,
    height: 12.7327,
    rx: 6.36636,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.102,
    y: 289.102,
    width: 109.024,
    height: 12.7327,
    rx: 6.36636,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.363 189.769H318.077L310.93 183.832C312.329 181.677 313.124 179.105 313.124 176.345C313.124 168.669 306.922 162.468 299.246 162.468C291.571 162.468 285.369 168.669 285.369 176.345C285.369 184.021 291.571 190.222 299.246 190.222C302.385 190.222 305.259 189.201 307.565 187.462L310.363 189.769ZM290.89 176.345C290.89 171.656 294.558 167.762 299.246 167.762C303.935 167.762 307.603 171.656 307.603 176.345C307.603 177.744 307.263 179.105 306.658 180.278L302.46 176.799L299.322 180.58L303.292 183.87C302.082 184.55 300.721 184.929 299.246 184.929C294.558 184.929 290.89 181.034 290.89 176.345ZM325.334 186.29C325.334 184.21 323.67 182.509 321.553 182.509C319.473 182.509 317.771 184.21 317.771 186.29C317.771 188.369 319.473 190.071 321.553 190.071C323.67 190.071 325.334 188.369 325.334 186.29Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 373,
    width: 158,
    height: 40,
    rx: 8,
    fill: "#FEC200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3313 401H92.6471L94.1723 397.419H100.848L102.373 401H105.733L98.9471 385.305H96.0955L89.3313 401ZM95.3439 394.612L97.5103 389.505L99.6766 394.612H95.3439ZM107.196 401H110.225V395.606C110.225 393.484 111.286 392.467 112.678 392.467C113.938 392.467 114.623 393.44 114.623 395.032V401H117.652V394.523C117.652 391.649 116.06 389.704 113.386 389.704C111.949 389.704 110.799 390.323 110.225 391.207V389.947H107.196V401ZM131.327 395.474C131.327 392.246 128.719 389.704 125.513 389.704C122.308 389.704 119.7 392.246 119.7 395.474C119.7 398.701 122.308 401.243 125.513 401.243C128.719 401.243 131.327 398.701 131.327 395.474ZM122.75 395.474C122.75 393.772 123.922 392.534 125.513 392.534C127.105 392.534 128.254 393.772 128.254 395.474C128.254 397.176 127.105 398.414 125.513 398.414C123.922 398.414 122.75 397.176 122.75 395.474ZM133.511 401H136.539V395.606C136.539 393.484 137.601 392.467 138.993 392.467C140.253 392.467 140.938 393.44 140.938 395.032V401H143.967V394.523C143.967 391.649 142.375 389.704 139.701 389.704C138.264 389.704 137.114 390.323 136.539 391.207V389.947H133.511V401ZM150.62 405.62L157.561 389.947H154.223L151.283 397.109L148.321 389.947H145.005L149.648 400.381L147.327 405.62H150.62ZM159.027 401H162.056V395.606C162.056 393.484 162.962 392.467 164.266 392.467C165.46 392.467 165.99 393.462 165.99 395.098V401H169.019V395.606C169.019 393.484 169.925 392.467 171.229 392.467C172.423 392.467 172.954 393.462 172.954 395.098V401H175.982V394.589C175.982 391.605 174.479 389.704 171.848 389.704C170.588 389.704 169.107 390.367 168.422 391.738C167.759 390.456 166.609 389.704 164.996 389.704C163.647 389.704 162.652 390.345 162.056 391.207V389.947H159.027V401ZM189.656 395.474C189.656 392.246 187.048 389.704 183.842 389.704C180.637 389.704 178.029 392.246 178.029 395.474C178.029 398.701 180.637 401.243 183.842 401.243C187.048 401.243 189.656 398.701 189.656 395.474ZM181.079 395.474C181.079 393.772 182.251 392.534 183.842 392.534C185.434 392.534 186.583 393.772 186.583 395.474C186.583 397.176 185.434 398.414 183.842 398.414C182.251 398.414 181.079 397.176 181.079 395.474ZM191.707 396.358C191.707 399.298 193.188 401.243 195.863 401.243C197.278 401.243 198.317 400.624 198.892 399.74V401H201.92V389.947H198.892V395.341C198.892 397.485 197.963 398.48 196.615 398.48C195.31 398.48 194.736 397.507 194.736 395.849V389.947H191.707V396.358ZM212.749 397.64C212.749 395.717 211.533 394.744 209.544 394.214L208.505 393.904C207.577 393.661 207.422 393.285 207.422 392.954C207.422 392.445 207.997 392.202 208.527 392.202C209.257 392.202 209.898 392.534 210.406 393.175L212.396 391.561C211.556 390.345 210.251 389.704 208.571 389.704C206.228 389.704 204.46 391.008 204.415 393.042C204.371 394.744 205.432 396.048 207.466 396.579L208.284 396.778C209.5 397.109 209.765 397.375 209.765 397.839C209.765 398.392 209.168 398.635 208.549 398.635C207.488 398.635 206.56 398.171 206.073 397.353L203.995 399.121C204.946 400.558 206.604 401.243 208.549 401.243C210.914 401.243 212.749 399.784 212.749 397.64ZM221.912 401H224.941V385.305H220.807L218.597 388.289H221.912V401Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 474,
    width: 162,
    height: 40,
    rx: 8,
    fill: "#FD8F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.065 502H298.38L299.906 498.419H306.582L308.107 502H311.467L304.68 486.305H301.829L295.065 502ZM301.077 495.612L303.244 490.505L305.41 495.612H301.077ZM312.929 502H315.958V496.606C315.958 494.484 317.019 493.467 318.412 493.467C319.672 493.467 320.357 494.44 320.357 496.032V502H323.385V495.523C323.385 492.649 321.794 490.704 319.119 490.704C317.682 490.704 316.533 491.323 315.958 492.207V490.947H312.929V502ZM337.06 496.474C337.06 493.246 334.452 490.704 331.247 490.704C328.041 490.704 325.433 493.246 325.433 496.474C325.433 499.701 328.041 502.243 331.247 502.243C334.452 502.243 337.06 499.701 337.06 496.474ZM328.483 496.474C328.483 494.772 329.655 493.534 331.247 493.534C332.838 493.534 333.988 494.772 333.988 496.474C333.988 498.176 332.838 499.414 331.247 499.414C329.655 499.414 328.483 498.176 328.483 496.474ZM339.244 502H342.273V496.606C342.273 494.484 343.334 493.467 344.726 493.467C345.986 493.467 346.672 494.44 346.672 496.032V502H349.7V495.523C349.7 492.649 348.109 490.704 345.434 490.704C343.997 490.704 342.848 491.323 342.273 492.207V490.947H339.244V502ZM356.354 506.62L363.295 490.947H359.957L357.017 498.109L354.055 490.947H350.739L355.381 501.381L353.06 506.62H356.354ZM364.761 502H367.789V496.606C367.789 494.484 368.695 493.467 370 493.467C371.193 493.467 371.724 494.462 371.724 496.098V502H374.752V496.606C374.752 494.484 375.659 493.467 376.963 493.467C378.156 493.467 378.687 494.462 378.687 496.098V502H381.715V495.589C381.715 492.605 380.212 490.704 377.582 490.704C376.322 490.704 374.841 491.367 374.155 492.738C373.492 491.456 372.343 490.704 370.729 490.704C369.381 490.704 368.386 491.345 367.789 492.207V490.947H364.761V502ZM395.389 496.474C395.389 493.246 392.781 490.704 389.576 490.704C386.37 490.704 383.762 493.246 383.762 496.474C383.762 499.701 386.37 502.243 389.576 502.243C392.781 502.243 395.389 499.701 395.389 496.474ZM386.812 496.474C386.812 494.772 387.984 493.534 389.576 493.534C391.167 493.534 392.317 494.772 392.317 496.474C392.317 498.176 391.167 499.414 389.576 499.414C387.984 499.414 386.812 498.176 386.812 496.474ZM397.441 497.358C397.441 500.298 398.922 502.243 401.596 502.243C403.011 502.243 404.05 501.624 404.625 500.74V502H407.653V490.947H404.625V496.341C404.625 498.485 403.696 499.48 402.348 499.48C401.044 499.48 400.469 498.507 400.469 496.849V490.947H397.441V497.358ZM418.483 498.64C418.483 496.717 417.267 495.744 415.277 495.214L414.238 494.904C413.31 494.661 413.155 494.285 413.155 493.954C413.155 493.445 413.73 493.202 414.26 493.202C414.99 493.202 415.631 493.534 416.139 494.175L418.129 492.561C417.289 491.345 415.985 490.704 414.305 490.704C411.961 490.704 410.193 492.008 410.149 494.042C410.105 495.744 411.166 497.048 413.199 497.579L414.017 497.778C415.233 498.109 415.498 498.375 415.498 498.839C415.498 499.392 414.901 499.635 414.283 499.635C413.221 499.635 412.293 499.171 411.807 498.353L409.729 500.121C410.679 501.558 412.337 502.243 414.283 502.243C416.648 502.243 418.483 500.784 418.483 498.64ZM435.891 499.016H429.392C429.812 497.999 431.47 497.137 432.443 496.407C434.432 494.948 435.758 493.578 435.758 490.881C435.758 487.676 433.371 486.04 430.718 486.04C427.602 486.04 425.236 488.162 425.236 491.235H428.287C428.265 489.975 429.259 489.024 430.652 489.024C432.001 489.024 432.73 489.908 432.73 491.058C432.73 492.34 431.625 493.313 430.254 494.285C427.955 495.943 425.192 497.446 425.192 500.961V502H435.891V499.016Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 373,
    width: 163,
    height: 40,
    rx: 8,
    fill: "#57C896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.403 401H416.719L418.244 397.419H424.92L426.445 401H429.805L423.019 385.305H420.167L413.403 401ZM419.415 394.612L421.582 389.505L423.748 394.612H419.415ZM431.267 401H434.296V395.606C434.296 393.484 435.357 392.467 436.75 392.467C438.01 392.467 438.695 393.44 438.695 395.032V401H441.723V394.523C441.723 391.649 440.132 389.704 437.457 389.704C436.02 389.704 434.871 390.323 434.296 391.207V389.947H431.267V401ZM455.398 395.474C455.398 392.246 452.79 389.704 449.585 389.704C446.379 389.704 443.771 392.246 443.771 395.474C443.771 398.701 446.379 401.243 449.585 401.243C452.79 401.243 455.398 398.701 455.398 395.474ZM446.822 395.474C446.822 393.772 447.993 392.534 449.585 392.534C451.176 392.534 452.326 393.772 452.326 395.474C452.326 397.176 451.176 398.414 449.585 398.414C447.993 398.414 446.822 397.176 446.822 395.474ZM457.582 401H460.611V395.606C460.611 393.484 461.672 392.467 463.065 392.467C464.325 392.467 465.01 393.44 465.01 395.032V401H468.038V394.523C468.038 391.649 466.447 389.704 463.772 389.704C462.335 389.704 461.186 390.323 460.611 391.207V389.947H457.582V401ZM474.692 405.62L481.633 389.947H478.295L475.355 397.109L472.393 389.947H469.077L473.719 400.381L471.398 405.62H474.692ZM483.099 401H486.127V395.606C486.127 393.484 487.033 392.467 488.338 392.467C489.531 392.467 490.062 393.462 490.062 395.098V401H493.09V395.606C493.09 393.484 493.997 392.467 495.301 392.467C496.495 392.467 497.025 393.462 497.025 395.098V401H500.053V394.589C500.053 391.605 498.55 389.704 495.92 389.704C494.66 389.704 493.179 390.367 492.493 391.738C491.83 390.456 490.681 389.704 489.067 389.704C487.719 389.704 486.724 390.345 486.127 391.207V389.947H483.099V401ZM513.727 395.474C513.727 392.246 511.119 389.704 507.914 389.704C504.708 389.704 502.1 392.246 502.1 395.474C502.1 398.701 504.708 401.243 507.914 401.243C511.119 401.243 513.727 398.701 513.727 395.474ZM505.151 395.474C505.151 393.772 506.322 392.534 507.914 392.534C509.505 392.534 510.655 393.772 510.655 395.474C510.655 397.176 509.505 398.414 507.914 398.414C506.322 398.414 505.151 397.176 505.151 395.474ZM515.779 396.358C515.779 399.298 517.26 401.243 519.935 401.243C521.349 401.243 522.388 400.624 522.963 399.74V401H525.991V389.947H522.963V395.341C522.963 397.485 522.035 398.48 520.686 398.48C519.382 398.48 518.807 397.507 518.807 395.849V389.947H515.779V396.358ZM536.821 397.64C536.821 395.717 535.605 394.744 533.615 394.214L532.576 393.904C531.648 393.661 531.493 393.285 531.493 392.954C531.493 392.445 532.068 392.202 532.599 392.202C533.328 392.202 533.969 392.534 534.477 393.175L536.467 391.561C535.627 390.345 534.323 389.704 532.643 389.704C530.3 389.704 528.531 391.008 528.487 393.042C528.443 394.744 529.504 396.048 531.537 396.579L532.355 396.778C533.571 397.109 533.836 397.375 533.836 397.839C533.836 398.392 533.24 398.635 532.621 398.635C531.56 398.635 530.631 398.171 530.145 397.353L528.067 399.121C529.017 400.558 530.675 401.243 532.621 401.243C534.986 401.243 536.821 399.784 536.821 397.64ZM554.671 396.535C554.671 394.766 553.654 393.528 552.483 392.976C553.389 392.357 554.229 391.119 554.229 389.594C554.229 387.096 552.372 385.04 549.145 385.04C546.382 385.04 543.685 386.963 543.685 390.235H546.735C546.713 388.953 547.73 388.024 549.145 388.024C550.294 388.024 551.201 388.754 551.179 389.837C551.157 390.942 550.383 391.716 548.924 391.716H547.73V394.192H549.057C550.604 394.192 551.621 394.987 551.621 396.292C551.599 397.485 550.604 398.259 549.233 398.259C547.686 398.259 546.559 397.441 546.404 395.916H543.398C543.508 399.364 546.249 401.243 549.233 401.243C552.483 401.243 554.671 399.298 554.671 396.535Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267,
    y1: 368,
    x2: 267,
    y2: 445,
    stroke: "#6442EF",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121,
    y1: 445,
    x2: 485.432,
    y2: 445,
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.913,
    y: 426.522,
    width: 35.015,
    height: 35.015,
    rx: 17.5075,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.42,
    cy: 444.03,
    r: 12.7327,
    fill: "#6442EF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.889,
    y: 426.522,
    width: 35.015,
    height: 35.015,
    rx: 17.5075,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.396,
    cy: 444.03,
    r: 12.7327,
    fill: "#FEC200"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.732,
    y: 426.522,
    width: 35.015,
    height: 35.015,
    rx: 17.5075,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.24,
    cy: 444.03,
    r: 12.7327,
    fill: "#FD8F55"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.552,
    y: 426.522,
    width: 35.015,
    height: 35.015,
    rx: 17.5075,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.059,
    cy: 444.03,
    r: 12.7327,
    fill: "#57C896"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 322,
    width: 59,
    height: 40,
    rx: 8,
    fill: "#6442EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.289 350H256.494V343.413L262.308 334.305H258.572L254.881 340.252L251.211 334.305H247.498L253.289 343.39V350ZM272.003 344.474C272.003 341.246 269.395 338.704 266.189 338.704C262.984 338.704 260.376 341.246 260.376 344.474C260.376 347.701 262.984 350.243 266.189 350.243C269.395 350.243 272.003 347.701 272.003 344.474ZM263.426 344.474C263.426 342.772 264.598 341.534 266.189 341.534C267.781 341.534 268.93 342.772 268.93 344.474C268.93 346.176 267.781 347.414 266.189 347.414C264.598 347.414 263.426 346.176 263.426 344.474ZM274.054 345.358C274.054 348.298 275.535 350.243 278.21 350.243C279.625 350.243 280.664 349.624 281.239 348.74V350H284.267V338.947H281.239V344.341C281.239 346.485 280.31 347.48 278.962 347.48C277.657 347.48 277.083 346.507 277.083 344.849V338.947H274.054V345.358Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 88.8828,
    y: 21,
    width: 429.084,
    height: 637.582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd",
    x: 217.081,
    y: 410.606,
    width: 98.6786,
    height: 98.6786,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.97897
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.9159
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.9159
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd",
    x: 108.057,
    y: 410.606,
    width: 98.6786,
    height: 98.6786,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.97897
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.9159
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.9159
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd",
    x: 316.901,
    y: 410.607,
    width: 98.6786,
    height: 98.6786,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.97897
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.9159
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.9159
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd",
    x: 436.72,
    y: 410.606,
    width: 98.6786,
    height: 98.6786,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.97897
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.9159
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.9159
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 642,
    height: 654,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerhome);
export default __webpack_public_path__ + "static/media/bannerhome.ef4ddb665a142c28602d03a055ce1fee.svg";
export { ForwardRef as ReactComponent };